import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useAlert } from '../components/GlobalAlert';

function MyTripsPage() {
  const { t } = useLanguage();
  const { showAlert } = useAlert();
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading trips data
    setTimeout(() => {
      setTrips([]);
      setLoading(false);
    }, 1000);
  }, []);

  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '10px',
      padding: '30px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      maxWidth: '1000px',
      margin: '0 auto',
    },
    title: {
      textAlign: 'center',
      marginBottom: '30px',
      color: '#333',
      fontSize: '28px',
      fontWeight: 'bold',
    },
    subtitle: {
      textAlign: 'center',
      fontSize: '16px',
      color: '#666',
      marginBottom: '30px',
    },
    emptyState: {
      textAlign: 'center',
      padding: '60px 20px',
      color: '#666',
    },
    emptyIcon: {
      fontSize: '64px',
      marginBottom: '20px',
      opacity: 0.5,
    },
    emptyTitle: {
      fontSize: '24px',
      fontWeight: '600',
      marginBottom: '10px',
      color: '#333',
    },
    emptyDescription: {
      fontSize: '16px',
      lineHeight: '1.5',
      marginBottom: '30px',
    },
    addTripButton: {
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
    },
    loading: {
      textAlign: 'center',
      padding: '60px 20px',
      color: '#666',
      fontSize: '16px',
    },
    tripsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '20px',
      marginTop: '30px',
    },
    tripCard: {
      backgroundColor: '#f8f9fa',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: '20px',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      cursor: 'pointer',
    },
    tripCardHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    tripHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '15px',
    },
    tripTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
    },
    tripStatus: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      color: 'white',
      backgroundColor: '#28a745',
    },
    tripDetails: {
      marginBottom: '15px',
    },
    tripDetail: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '8px',
      fontSize: '14px',
    },
    tripDetailLabel: {
      color: '#666',
      fontWeight: '500',
    },
    tripDetailValue: {
      color: '#333',
      fontWeight: '600',
    },
    tripActions: {
      display: 'flex',
      gap: '10px',
    },
    actionButton: {
      padding: '6px 12px',
      border: '1px solid #dee2e6',
      backgroundColor: 'white',
      color: '#495057',
      borderRadius: '4px',
      fontSize: '12px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    actionButtonHover: {
      backgroundColor: '#e9ecef',
      borderColor: '#adb5bd',
    },
  };

  const handleAddTrip = () => {
    showAlert('🚧 ' + t('featureComingSoon'), 'info');
  };

  const handleTripClick = (trip) => {
    showAlert('🚧 ' + t('featureComingSoon'), 'info');
  };

  return (
    <div style={styles.card}>
      <h1 style={styles.title}>{t('myTrips')}</h1>
      <p style={styles.subtitle}>
        {t('myTripsDescription')}
      </p>

      {loading ? (
        <div style={styles.loading}>
          ✈️ {t('loading')}...
        </div>
      ) : trips.length === 0 ? (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>✈️</div>
          <div style={styles.emptyTitle}>{t('noTripsYet')}</div>
          <div style={styles.emptyDescription}>
            {t('noTripsDescription')}
          </div>
          <button 
            style={styles.addTripButton}
            onClick={handleAddTrip}
          >
            {t('addFirstTrip')}
          </button>
        </div>
      ) : (
        <div style={styles.tripsGrid}>
          {trips.map((trip) => (
            <div 
              key={trip.id} 
              style={styles.tripCard}
              onClick={() => handleTripClick(trip)}
            >
              <div style={styles.tripHeader}>
                <div style={styles.tripTitle}>{trip.title}</div>
                <span style={styles.tripStatus}>{trip.status}</span>
              </div>
              <div style={styles.tripDetails}>
                <div style={styles.tripDetail}>
                  <span style={styles.tripDetailLabel}>{t('destination')}:</span>
                  <span style={styles.tripDetailValue}>{trip.destination}</span>
                </div>
                <div style={styles.tripDetail}>
                  <span style={styles.tripDetailLabel}>{t('date')}:</span>
                  <span style={styles.tripDetailValue}>{trip.date}</span>
                </div>
                <div style={styles.tripDetail}>
                  <span style={styles.tripDetailLabel}>{t('duration')}:</span>
                  <span style={styles.tripDetailValue}>{trip.duration}</span>
                </div>
              </div>
              <div style={styles.tripActions}>
                <button style={styles.actionButton}>{t('view')}</button>
                <button style={styles.actionButton}>{t('edit')}</button>
                <button style={styles.actionButton}>{t('delete')}</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MyTripsPage; 